
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/ads",
      function () {
        return require("private-next-pages/product/ads/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/ads"])
      });
    }
  